import React, { useContext, useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { OrderDirection, PagesFilterResponse } from '../../Models/Models';
import { SiteContext } from '../../Contexts';
import { EntityColors } from '../../Themes/EntityColors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFont, faListOl } from '@fortawesome/free-solid-svg-icons';
import { Utils } from '../../Services/Utils';
import { PageService } from '../../Services/PageService';
import TableShell from '../Table/TableShell';
import TableToolbar from '../Table/TableToolbar';

const PageTableComponent = () => {
    useEffect(() => {
        Utils.setDocumentTitle('Stránky');
    }, []);

    const { filterPages } = PageService();
    const [response, setResponse] = useState<PagesFilterResponse | null>(null);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(6);
    const [orderDirection, setOrderDirection] = useState<OrderDirection>('Desc');
    const { currentSite }: any = useContext(SiteContext);
    const { action, icon } = EntityColors.page;

    const loadPage = async (pageNum: number, opts?: { perPage?: number; order?: OrderDirection }) => {
        const limit = opts?.perPage ?? perPage;
        const resp = await filterPages({
            websiteId: currentSite.id,
            limit,
            offset: (pageNum - 1) * limit,
            orderDirection: opts?.order ?? orderDirection,
        });
        setResponse(resp ?? null);
    };

    const changePerPage = (count: number) => {
        setPerPage(count);
        setPage(1);
        void loadPage(1, { perPage: count });
    };

    const changeOrder = (dir: OrderDirection) => {
        setOrderDirection(dir);
        setPage(1);
        void loadPage(1, { order: dir });
    };

    useEffect(() => {
        setPage(1);
        void loadPage(1);
    }, [currentSite]);

    return (
        <TableShell
            title="Stránky"
            icon={icon}
            accentColor={action}
            isLoading={response === null}
            isEmpty={response !== null && response.data.length === 0}
            emptyMessage="Žiadne stránky"
            page={page}
            totalCount={response?.totalCount}
            perPage={perPage}
            onPageChange={p => { setPage(p); loadPage(p); }}
            headerActions={
                <Link to="/text/table" className="st-btn st-btn--outline">
                    <FontAwesomeIcon icon={faFont} className="st-table-shell-create-icon" />
                    Všetky texty
                </Link>
            }
            toolbar={
                <TableToolbar
                    totalCount={response?.totalCount ?? 0}
                    nounForms={['stránka', 'stránky', 'stránok']}
                    perPage={perPage}
                    onPerPageChange={changePerPage}
                    orderDirection={orderDirection}
                    onOrderChange={changeOrder}
                />
            }
        >
            <Table responsive>
                <thead>
                    <tr>
                        <th>Kód stránky</th>
                        <th className="text-center">Akcie</th>
                    </tr>
                </thead>
                <tbody>
                    {response?.data.map(p => (
                        <tr key={p.id}>
                            <td style={{ fontWeight: 500 }}>{p.code}</td>
                            <td className="text-center">
                                <div style={{ display: 'inline-flex', gap: '0.5rem', flexWrap: 'wrap', justifyContent: 'center' }}>
                                    <Link to={`/section/table/${p.id}`} style={{ textDecoration: 'none' }}>
                                        <button
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '0.35rem',
                                                padding: '0.35rem 0.75rem',
                                                borderRadius: '7px',
                                                border: 'none',
                                                backgroundColor: action,
                                                color: 'white',
                                                fontWeight: 600,
                                                fontSize: '0.78rem',
                                                cursor: 'pointer',
                                                transition: 'filter 0.15s',
                                            }}
                                            onMouseEnter={e => (e.currentTarget.style.filter = 'brightness(88%)')}
                                            onMouseLeave={e => (e.currentTarget.style.filter = 'brightness(100%)')}
                                        >
                                            <FontAwesomeIcon icon={faListOl} style={{ fontSize: '0.7rem' }} />
                                            Sekcie
                                        </button>
                                    </Link>
                                    <Link to={`/text/table/${p.id}`} style={{ textDecoration: 'none' }}>
                                        <button
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '0.35rem',
                                                padding: '0.35rem 0.75rem',
                                                borderRadius: '7px',
                                                border: `1.5px solid ${action}`,
                                                backgroundColor: 'transparent',
                                                color: action,
                                                fontWeight: 600,
                                                fontSize: '0.78rem',
                                                cursor: 'pointer',
                                                transition: 'background-color 0.15s',
                                            }}
                                            onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#F5F3FF'; }}
                                            onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                                        >
                                            <FontAwesomeIcon icon={faListOl} style={{ fontSize: '0.7rem' }} />
                                            Texty
                                        </button>
                                    </Link>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </TableShell>
    );
};

export default PageTableComponent;
